export default __webpack_public_path__ + "static/media/berenice-krzyzaniak-boudot-resume.9a7807c4.pdf";